import React, { useState } from 'react';
import { MenuIcon, XIcon, NavigationIcon } from 'lucide-react';
const NAV = [{
  label: 'How it works',
  href: '#how-it-works'
}, {
  label: 'Features',
  href: '#features'
}, {
  label: 'FAQs',
  href: '#faqs'
}];
export function Header() {
  const [open, setOpen] = useState(false);
  return <header className="sticky top-0 z-50 w-full border-b border-line bg-white/85 backdrop-blur-md" data-id="element-82" data-mp="2nktz26ietdf9">
      <div className="mx-auto flex h-16 w-full max-w-6xl items-center justify-between px-5 sm:px-8" data-id="element-83" data-mp="2rl46zopridwr">
        <a href="#top" className="flex items-center gap-2 font-extrabold text-ink" data-id="element-84" data-mp="2wk72ahfxx5rj">
          <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-ink text-white" data-id="element-85" data-mp="31bp2326890ax">
            <NavigationIcon className="h-4 w-4" data-id="element-86" data-mp="36bbfpcpywik9" />
          </span>
          <span className="text-lg tracking-tight" data-id="element-87" data-mp="36cwddb7kwhmc">GPS Journal</span>
        </a>

        <nav className="hidden items-center gap-8 md:flex" data-id="element-88" data-mp="3b81u7vm4j63k">
          {NAV.map(item => <a key={item.href} href={item.href} className="text-sm font-medium text-muted transition-colors hover:text-ink" data-id="element-89" data-mp="3fbzsy57jeew3">
              {item.label}
            </a>)}
        </nav>

        <div className="flex items-center gap-3" data-id="element-90" data-mp="2mm55p4iru4rm">
          <a href="#pricing" className="hidden rounded-full bg-ink px-5 py-2.5 text-sm font-semibold text-white transition-transform hover:scale-[1.03] sm:inline-flex" data-id="element-91" data-mp="2mmx0we8gi0hd">
            Get GPS Journal
          </a>
          <button type="button" aria-label={open ? 'Close menu' : 'Open menu'} onClick={() => setOpen(v => !v)} className="flex h-9 w-9 items-center justify-center rounded-lg text-ink md:hidden" data-id="element-92" data-mp="3abpq7rukpa30">
            {open ? <XIcon className="h-5 w-5" data-id="element-93" data-mp="30klm5n6fr9my" /> : <MenuIcon className="h-5 w-5" data-id="element-94" data-mp="1wzaccnd9ff2" />}
          </button>
        </div>
      </div>

      {open && <div className="border-t border-line bg-white md:hidden" data-id="element-95" data-mp="3tav98nfqppky">
          <nav className="mx-auto flex w-full max-w-6xl flex-col gap-1 px-5 py-3" data-id="element-96" data-mp="3t9ahf5kt8kqs">
            {NAV.map(item => <a key={item.href} href={item.href} onClick={() => setOpen(false)} className="rounded-lg px-3 py-2.5 text-sm font-medium text-ink hover:bg-neutral-50" data-id="element-97" data-mp="1wceei1qz0uvz">
                {item.label}
              </a>)}
            <a href="#pricing" onClick={() => setOpen(false)} className="mt-1 rounded-full bg-ink px-3 py-2.5 text-center text-sm font-semibold text-white" data-id="element-98" data-mp="18mk4rt1y7mfy">
              Get GPS Journal
            </a>
          </nav>
        </div>}
    </header>;
}